import { format } from 'date-fns';

const formatWeekdayName = (date, {
  locale
}) => format(date, 'iiiiii', {
  locale
});
const formatCaption = (date, {
  locale
}) => format(date, 'LLLL yyy', {
  locale
});

export { formatCaption, formatWeekdayName };
